import { cn } from '@bem-react/classname';

export const cnPublicationMini = cn('PublicationMini');
export const publicationMiniCn = cnPublicationMini();
export const publicationMiniContentCn = cnPublicationMini('Content');
export const publicationMiniImgContainerCn = cnPublicationMini('ImgContainer');
export const publicationMiniImgCn = cnPublicationMini('Img');
export const publicationMiniPriceCn = cnPublicationMini('Price');
export const publicationMiniTypeApartmentCn = cnPublicationMini('TypeApartment');
export const publicationMiniAddressCn = cnPublicationMini('Address');
